// Lower case to match checkr package names (aligned with Prisma `BackgroundCheckPackage`)
export enum BackgroundCheckPackage {
  BASIC_CRIMINAL = 'basic_criminal',
  PREMIUM_CRIMINAL = 'premium_criminal',
  BASIC_FEDERAL = 'basic_federal',
  ESSENTIAL_CRIMINAL = 'essential_criminal',
  PROGRESSIVE_ESSENTIAL = 'progressive_essential',
  /** Internal / elevated flows only — not selectable in ops application configuration */
  UNLIMITED_COUNTY_CRIMINAL_7X7_ONLY = 'unlimited_county_criminal_7x7_only',
}

export enum BackgroundCheckExpirationType {
  NEVER = 'NEVER',
  ONE_YEAR = 'ONE_YEAR',
}

export enum BackgroundCheckLevel {
  STANDARD = 'STANDARD',
  SPOTLESS = 'SPOTLESS',
}

export type BackgroundCheckConfiguration = {
  package: BackgroundCheckPackage
  expirationType: BackgroundCheckExpirationType
  passingLevel: BackgroundCheckLevel
}

// Display labels for the enum values
export const BACKGROUND_CHECK_PACKAGE_LABELS: Record<
  BackgroundCheckPackage,
  string
> = {
  [BackgroundCheckPackage.BASIC_CRIMINAL]: 'Basic Criminal',
  [BackgroundCheckPackage.PREMIUM_CRIMINAL]: 'Premium Criminal',
  [BackgroundCheckPackage.BASIC_FEDERAL]: 'Basic Federal (More Expensive)',
  [BackgroundCheckPackage.ESSENTIAL_CRIMINAL]: 'Essential Criminal',
  [BackgroundCheckPackage.PROGRESSIVE_ESSENTIAL]: 'Progressive Essential',
  [BackgroundCheckPackage.UNLIMITED_COUNTY_CRIMINAL_7X7_ONLY]:
    'Unlimited County Criminal 7x7 Only',
}

/**
 * Packages ops may assign when configuring a background check application step.
 * Excludes `unlimited_county_criminal_7x7_only` (reserved for internal elevated Checkr flows).
 */
export const BACKGROUND_CHECK_PACKAGES_APPLICATION_CONFIGURABLE: readonly BackgroundCheckPackage[] =
  [
    BackgroundCheckPackage.BASIC_CRIMINAL,
    BackgroundCheckPackage.ESSENTIAL_CRIMINAL,
    BackgroundCheckPackage.PROGRESSIVE_ESSENTIAL,
    BackgroundCheckPackage.PREMIUM_CRIMINAL,
    BackgroundCheckPackage.BASIC_FEDERAL,
  ]

export const BACKGROUND_CHECK_EXPIRATION_LABELS: Record<
  BackgroundCheckExpirationType,
  string
> = {
  [BackgroundCheckExpirationType.NEVER]: 'Never',
  [BackgroundCheckExpirationType.ONE_YEAR]: 'One Year',
}

export const BACKGROUND_CHECK_LEVEL_LABELS: Record<
  BackgroundCheckLevel,
  string
> = {
  [BackgroundCheckLevel.STANDARD]: 'Standard',
  [BackgroundCheckLevel.SPOTLESS]: 'Spotless',
}
